__turbopack_context__.v({
  "extraWide": "Layout-module-scss-module__St0g-q__extraWide",
  "mainContainer": "Layout-module-scss-module__St0g-q__mainContainer",
  "mainContent": "Layout-module-scss-module__St0g-q__mainContent",
  "wholePage": "Layout-module-scss-module__St0g-q__wholePage",
});
